import { type TimedClass, classTimeText } from "@/lib/class-time"

// A class time in the viewer's zone, with school time underneath when the
// two differ.
export function ClassTime({
  session,
  schoolTimeZone,
  viewerTimeZone,
  className,
}: {
  session: TimedClass
  schoolTimeZone?: string | null
  viewerTimeZone?: string | null
  className?: string
}) {
  const text = classTimeText(session, schoolTimeZone, viewerTimeZone)
  return (
    <span className={className}>
      {text.localDay && `${text.localDay} · `}
      {text.primary}
      {text.school && (
        <span className="text-muted-foreground block text-xs font-normal">
          School time: {text.school}
        </span>
      )}
    </span>
  )
}
